import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { OrderTypeEnum } from './useOrderTypeStore';
import { ISearch } from '@/hooks/useSearchStore';
import { Dayjs } from 'dayjs';

export interface OrderFilters {
  searchValue?: ISearch;
  createdAtFilter?: [Dayjs, Dayjs];
  orderTypeFilter?: OrderTypeEnum[];
  printedFilter?: boolean;
  partiallyDeliveredFilter?: boolean;
}

interface StoreAndActions extends OrderFilters {
  currentPage: number;

  setCurrentPage: (page: number) => void;
  setSearchValue: (value: ISearch) => void;
  setCreatedAt: (value?: [Dayjs, Dayjs]) => void;
  setOrderType: (value: OrderTypeEnum[]) => void;
  setPrinted: (value?: boolean) => void;
  setPartiallyDelivered: (value?: boolean) => void;
  resetFilers: () => void;
}

export const emptySearchValue = { search: null, searchBy: null };

const useFilterOrderStore = create<StoreAndActions>((set, get) => ({
  currentPage: 1,
  searchValue: emptySearchValue,
  createdAtFilter: undefined,
  orderTypeFilter: [],
  printedFilter: undefined,
  partiallyDeliveredFilter: undefined,

  setCurrentPage: (page) => set({ currentPage: page }),
  setSearchValue: (value) => set({ searchValue: value }),
  setCreatedAt: (value) => set({ createdAtFilter: value }),
  setOrderType: (value) => set({ orderTypeFilter: [...value] }),
  setPrinted: (value) => set({ printedFilter: value }),
  setPartiallyDelivered: (value) => set({ partiallyDeliveredFilter: value }),
  resetFilers: () => {
    set({
      currentPage: 1,

      createdAtFilter: undefined,
      orderTypeFilter: [],
      printedFilter: undefined,
      partiallyDeliveredFilter: undefined,
      searchValue: emptySearchValue,
    });
  },
}));

/**
 * Every list filter, read in one place. The orders list, the per-tab data and
 * "Export this list" all take their filters from here, so a new filter added to
 * OrderFilters reaches all three (BOXY-378: a filter wired into only the store
 * never reached the API).
 */
export const selectOrderFilters = (state: OrderFilters): OrderFilters => ({
  searchValue: state.searchValue,
  createdAtFilter: state.createdAtFilter,
  orderTypeFilter: state.orderTypeFilter,
  printedFilter: state.printedFilter,
  partiallyDeliveredFilter: state.partiallyDeliveredFilter,
});

export const useOrderFilters = () => useFilterOrderStore(useShallow(selectOrderFilters));

export default useFilterOrderStore;
